import {Component, Input, TrackByFunction} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {DynamicFormService} from '../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../events/event-dispatcher.service';
import {FieldConfig} from '../../dynamic-field/field.config';

@Component({
    selector: 'mydocma-dynamic-form-list-layout',
    templateUrl: './list-layout.component.html',
    styleUrls: ['./list-layout.component.scss'],
})
export class ListLayoutComponent {

    @Input() fieldWrapper;

    @Input() formGroup: UntypedFormGroup;

    constructor(
        public readonly formService: DynamicFormService,
        public readonly eventDispatcher: EventDispatcherService
    ) {
    }
}
